var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0662B9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.3,9.5L18.7,13l-3.3-4.4l-3.6,3.6l9.5,9.6V9.5z M10.8,13l-9.5,9.6h19L10.8,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,0.4c-2.1,0-3.9,1.7-3.9,3.9c0,0.8,0.3,1.7,0.8,2.3l3.1,4.2l3.1-4.2c0.5-0.7,0.8-1.5,0.8-2.3 C22.6,2.2,20.8,0.4,18.7,0.4z M18.7,6.3c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9c1.1,0,1.9,0.9,1.9,1.9S19.8,6.3,18.7,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,3.7C18.3,3.7,18,4,18,4.3C18,4.7,18.3,5,18.7,5c0.4,0,0.6-0.3,0.6-0.6C19.3,4,19,3.7,18.7,3.7z  M14.5,7.4c-0.7-0.9-1-2-1-3.1c0-0.9,0.3-1.8,0.7-2.6H0.4v19.9L14.5,7.4L14.5,7.4z M9.5,7.6c0,1.8-1.5,3.2-3.2,3.2S3,9.4,3,7.6 c0-1.2,0.7-2.3,1.8-2.9C6,4.1,7.4,4.3,8.5,5.1l-0.8,1C7,5.6,6.1,5.5,5.4,5.8c-0.7,0.3-1.1,1-1.1,1.7c0,1.1,0.9,1.9,1.9,1.9 c0.8,0,1.6-0.5,1.8-1.3H6.9V6.9h2.6V7.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMap);
export default __webpack_public_path__ + "static/media/google-map.30c720e5e828025c021a1bb191599202.svg";
export { ForwardRef as ReactComponent };